import { render, staticRenderFns } from "./Ice.vue?vue&type=template&id=17aa7e22&scoped=true&"
import script from "./Ice.vue?vue&type=script&lang=js&"
export * from "./Ice.vue?vue&type=script&lang=js&"
import style0 from "./Ice.vue?vue&type=style&index=0&id=17aa7e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aa7e22",
  null
  
)

export default component.exports